export default theme => {
    return {}
}


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTech/theme/components/scorecard/ScorecardView/ScorecardExport.js